import { isMemberBusinessAccountType } from 'types'
import displayMemberName from './displayMemberName'

// Account-level display name: business accounts use Account.name (company);
// otherwise prefer contact first/last via displayMemberName (SF name can lag).
function displayNameForAccount(account, contact) {
  if (isMemberBusinessAccountType(account?.account_detail_type__c)) {
    return account?.name
  }

  return displayMemberName(contact, account)
}

export default displayNameForAccount
